import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import useScrollToTop from '../../hooks/useScrollToTop';
import { Container, Title, Section, SubTitle, Text, BackButton } from './styles';

const PrivacyPolicy = () => {
  useScrollToTop();
  return (
    <>
      <Header />
      <Container>
        <Title>Política de Privacidade</Title>
        <Section>
          <Text>
            A FluencIA está comprometida com a proteção da sua privacidade. Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos suas informações pessoais ao utilizar nossos serviços de aprendizado de inglês.
          </Text>
        </Section>

        {/* INTRODUÇÃO */}
        <Section>
          <SubTitle>1. Introdução e Âmbito</SubTitle>
          <Text>
            Esta Política de Privacidade se aplica a todos os serviços oferecidos pela FluencIA, incluindo nossa plataforma de ensino via WhatsApp, nosso aplicativo móvel e website. Ao utilizar qualquer um destes serviços, você concorda com a coleta e uso de informações de acordo com esta política. Recomendamos a leitura atenta deste documento para compreender como tratamos seus dados pessoais e quais são seus direitos em relação a eles.
          </Text>
        </Section>

        <Section>
          <SubTitle>2. Controlador de Dados</SubTitle>
          <Text>
            Para fins da Lei Geral de Proteção de Dados (LGPD) e outras leis de proteção de dados aplicáveis, o controlador de dados é FluencIA Tecnologia Educacional Ltda., inscrita no CNPJ sob o nº XX.XXX.XXX/0001-XX, com sede na [Endereço Completo], Brasil. Nosso Encarregado de Proteção de Dados (DPO) pode ser contatado através do e-mail dpo@inglesfluencia.com.br.
          </Text>
        </Section>

        {/* COLETA DE DADOS */}
        <Section>
          <SubTitle>3. Dados Que Coletamos</SubTitle>
          <Text>
            Para fornecer nossos serviços de ensino personalizado, coletamos as seguintes categorias de dados pessoais:
            <br /><br />
            <strong>a) Dados de Identificação:</strong> nome completo, endereço de e-mail, número de telefone (WhatsApp), dados de perfil (foto quando fornecida voluntariamente).
            <br /><br />
            <strong>b) Dados de Aprendizado:</strong> nível de proficiência em inglês, histórico de exercícios realizados, respostas aos desafios, frequência de uso, preferências de aprendizagem, áreas de dificuldade, progresso nas lições.
            <br /><br />
            <strong>c) Dados de Uso:</strong> interações com nossa plataforma, tempo de utilização, dados de engajamento, frequência de acesso, horários de maior atividade.
            <br /><br />
            <strong>d) Dados de Pagamento:</strong> informações de cartão de crédito (processadas de forma segura por nossos processadores de pagamento), histórico de assinaturas, datas de cobrança.
            <br /><br />
            <strong>e) Dados Técnicos:</strong> endereço IP, tipo de dispositivo, sistema operacional, informações do navegador, identificadores únicos de dispositivo.
            <br /><br />
            <strong>f) Comunicações:</strong> conteúdo das mensagens trocadas com nosso serviço via WhatsApp, e-mails enviados para nosso suporte ou outras interações.
          </Text>
        </Section>

        <Section>
          <SubTitle>4. Como Coletamos Seus Dados</SubTitle>
          <Text>
            Coletamos seus dados pessoais das seguintes formas:
            <br /><br />
            <strong>a) Fornecidos Diretamente Por Você:</strong> informações que você nos fornece durante o cadastro, ao responder nossos exercícios, ao atualizar seu perfil ou ao entrar em contato com nosso suporte.
            <br /><br />
            <strong>b) Coletados Automaticamente:</strong> através do uso de cookies, análise de interações com nossa plataforma via WhatsApp e aplicativo, e registros de uso de nossos serviços.
            <br /><br />
            <strong>c) De Plataformas de Terceiros:</strong> podemos receber informações quando você se inscreve ou acessa nossos serviços através de plataformas de terceiros, como Google, Apple ou Facebook, sempre respeitando suas configurações de privacidade nessas plataformas.
            <br /><br />
            <strong>d) Via WhatsApp:</strong> como nosso serviço principal opera via WhatsApp, coletamos e processamos o conteúdo das mensagens trocadas com nossa plataforma, incluindo textos, áudios e, ocasionalmente, imagens que você compartilha durante o aprendizado.
          </Text>
        </Section>

        {/* USO DE DADOS */}
        <Section>
          <SubTitle>5. Como Usamos Seus Dados</SubTitle>
          <Text>
            Utilizamos seus dados pessoais para as seguintes finalidades:
            <br /><br />
            <strong>a) Prestação de Serviços:</strong> para fornecer nossa plataforma de ensino personalizado, adaptando o conteúdo e os exercícios ao seu nível e necessidades específicas de aprendizado.
            <br /><br />
            <strong>b) Personalização:</strong> para criar uma experiência de aprendizado personalizada, incluindo recomendações de conteúdo, ajuste de dificuldade e lembretes personalizados.
            <br /><br />
            <strong>c) Processamento de Pagamentos:</strong> para processar suas assinaturas e gerenciar aspectos financeiros da sua conta.
            <br /><br />
            <strong>d) Análise e Melhorias:</strong> para analisar como nossos serviços são utilizados, identificar tendências de uso e áreas para melhoria, e otimizar a experiência do usuário.
            <br /><br />
            <strong>e) Comunicações:</strong> para enviar notificações sobre seu progresso, lembretes de exercícios, atualizações de serviço e, com sua permissão, materiais promocionais ou educacionais adicionais.
            <br /><br />
            <strong>f) Suporte ao Cliente:</strong> para responder às suas dúvidas, solucionar problemas e fornecer assistência técnica.
            <br /><br />
            <strong>g) Segurança e Conformidade:</strong> para proteger nossos serviços, detectar e prevenir fraudes, abusos e violações de segurança, e cumprir com obrigações legais.
            <br /><br />
            <strong>h) Treinamento de IA:</strong> para treinar e melhorar nossos algoritmos de inteligência artificial que fornecem feedback e correções personalizadas (sempre com dados anonimizados quando utilizados para este fim).
          </Text>
        </Section>

        <Section>
          <SubTitle>6. Base Legal para o Processamento</SubTitle>
          <Text>
            Processamos seus dados pessoais com base nas seguintes bases legais previstas na LGPD:
            <br /><br />
            <strong>a) Execução de Contrato:</strong> processamos seus dados para cumprir obrigações contratuais com você, incluindo a prestação de nossos serviços de ensino conforme contratados.
            <br /><br />
            <strong>b) Consentimento:</strong> quando explicitamente solicitado e concedido por você, como para envio de comunicações de marketing.
            <br /><br />
            <strong>c) Interesses Legítimos:</strong> para melhorar nossos serviços, garantir segurança da plataforma, prevenir fraudes e personalizar sua experiência de aprendizado.
            <br /><br />
            <strong>d) Obrigação Legal:</strong> quando necessário para cumprir com obrigações legais, como manter registros para fins fiscais.
            <br /><br />
            <strong>e) Proteção ao Crédito:</strong> para atividades relacionadas à verificação de crédito e gestão de pagamentos.
          </Text>
        </Section>

        {/* COMPARTILHAMENTO E ARMAZENAMENTO */}
        <Section>
          <SubTitle>7. Compartilhamento de Dados</SubTitle>
          <Text>
            A FluencIA não vende, aluga ou comercializa seus dados pessoais. Compartilhamos suas informações apenas nas seguintes circunstâncias:
            <br /><br />
            <strong>a) Prestadores de Serviços:</strong> compartilhamos dados com fornecedores que nos ajudam a operar nossos serviços, como processadores de pagamento, serviços de hospedagem em nuvem e ferramentas de análise. Estes fornecedores estão sujeitos a obrigações contratuais de confidencialidade e segurança.
            <br /><br />
            <strong>b) Plataforma WhatsApp:</strong> como nosso serviço opera principalmente via WhatsApp, suas interações com nossa plataforma estão sujeitas também à política de privacidade do WhatsApp.
            <br /><br />
            <strong>c) Parceiros de Negócios:</strong> em alguns casos, podemos compartilhar dados agregados e anonimizados com parceiros educacionais para melhorar nossos materiais e métodos de ensino.
            <br /><br />
            <strong>d) Requisitos Legais:</strong> quando exigido por lei, ordem judicial ou autoridade competente.
            <br /><br />
            <strong>e) Proteção de Direitos:</strong> quando necessário para proteger nossos direitos, propriedade ou segurança, ou os direitos, propriedade ou segurança de nossos usuários ou outros.
            <br /><br />
            <strong>f) Reorganização Empresarial:</strong> em caso de fusão, aquisição ou venda de ativos, seus dados podem ser transferidos como parte desse processo, mantendo-se as mesmas garantias e nível de proteção.
          </Text>
        </Section>

        <Section>
          <SubTitle>8. Transferências Internacionais</SubTitle>
          <Text>
            Alguns de nossos fornecedores de serviços podem estar localizados fora do Brasil. Quando transferimos seus dados para outros países, garantimos que essas transferências sejam realizadas de acordo com a LGPD e outras leis aplicáveis, implementando medidas de segurança adequadas, como cláusulas contratuais padrão ou certificações reconhecidas. Nossos principais servidores estão localizados nos Estados Unidos e na União Europeia, regiões com robustos marcos regulatórios de proteção de dados.
          </Text>
        </Section>

        <Section>
          <SubTitle>9. Armazenamento e Segurança</SubTitle>
          <Text>
            Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais contra acesso não autorizado, uso indevido, perda ou destruição, incluindo:
            <br /><br />
            <strong>a) Criptografia:</strong> utilizamos criptografia de ponta a ponta para comunicações sensíveis e criptografia em repouso para dados armazenados.
            <br /><br />
            <strong>b) Controles de Acesso:</strong> implementamos controles estritos de acesso para garantir que apenas pessoal autorizado possa acessar seus dados.
            <br /><br />
            <strong>c) Monitoramento:</strong> monitoramos constantemente nossos sistemas para detectar possíveis vulnerabilidades ou tentativas de invasão.
            <br /><br />
            <strong>d) Revisões Regulares:</strong> realizamos auditorias de segurança periódicas e testes de penetração em nossos sistemas.
            <br /><br />
            <strong>e) Treinamento:</strong> nossa equipe recebe treinamento regular sobre melhores práticas de segurança e proteção de dados.
            <br /><br />
            Apesar de nossos esforços, nenhum sistema é 100% seguro. Em caso de violação de dados que possa afetar sua privacidade, comprometemo-nos a notificá-lo prontamente, conforme exigido por lei.
          </Text>
        </Section>

        <Section>
          <SubTitle>10. Retenção de Dados</SubTitle>
          <Text>
            Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades para as quais foram coletados, incluindo obrigações legais, fiscais, contábeis ou de relatórios. Para determinar o período de retenção apropriado, consideramos:
            <br /><br />
            <strong>a) Período de Assinatura Ativa:</strong> mantemos seus dados completos enquanto você mantiver uma assinatura ativa do nosso serviço.
            <br /><br />
            <strong>b) Após Cancelamento:</strong> se você cancelar sua assinatura, manteremos seus dados principais e histórico de aprendizado por até 12 meses para facilitar sua reativação.
            <br /><br />
            <strong>c) Dados Anonimizados:</strong> após este período, podemos reter dados anonimizados para fins estatísticos e de pesquisa, que não podem mais ser associados a você.
            <br /><br />
            <strong>d) Obrigações Legais:</strong> alguns dados podem ser mantidos por períodos mais longos para cumprir com obrigações legais (como registros fiscais).
            <br /><br />
            <strong>e) Exclusão Antecipada:</strong> você pode solicitar a exclusão antecipada dos seus dados, conforme detalhado na seção sobre seus direitos.
          </Text>
        </Section>

        {/* COOKIES E TECNOLOGIAS */}
        <Section>
          <SubTitle>11. Cookies e Tecnologias Semelhantes</SubTitle>
          <Text>
            Nosso aplicativo e site utilizam cookies e tecnologias semelhantes para melhorar sua experiência:
            <br /><br />
            <strong>a) Cookies Essenciais:</strong> necessários para o funcionamento básico da plataforma, como autenticação e segurança.
            <br /><br />
            <strong>b) Cookies de Preferências:</strong> armazenam suas preferências e configurações.
            <br /><br />
            <strong>c) Cookies Analíticos:</strong> nos ajudam a entender como você interage com nossa plataforma, permitindo-nos melhorá-la.
            <br /><br />
            <strong>d) Cookies de Marketing:</strong> utilizados para personalizar anúncios e conteúdo relevante (estes só são usados com seu consentimento explícito).
            <br /><br />
            Você pode gerenciar suas preferências de cookies através das configurações do seu navegador ou do nosso painel de preferências de privacidade. Lembramos que desabilitar certos cookies pode afetar a funcionalidade do nosso serviço.
          </Text>
        </Section>

        <Section>
          <SubTitle>12. Uso de Inteligência Artificial</SubTitle>
          <Text>
            Como uma plataforma de ensino baseada em IA, utilizamos tecnologias avançadas de processamento de linguagem natural e aprendizado de máquina para personalizar sua experiência educacional:
            <br /><br />
            <strong>a) Análise de Linguagem:</strong> nossa IA analisa suas respostas para identificar padrões, erros e áreas para melhoria.
            <br /><br />
            <strong>b) Personalização:</strong> nossos algoritmos adaptam exercícios e feedback com base no seu desempenho e necessidades específicas.
            <br /><br />
            <strong>c) Treinamento de Modelos:</strong> utilizamos dados anonimizados para treinar e melhorar nossos modelos de IA, sempre preservando sua privacidade.
            <br /><br />
            <strong>d) Decisões Automatizadas:</strong> nosso sistema pode tomar decisões automatizadas sobre seu nível de proficiência e recomendações de estudo, mas você sempre pode solicitar intervenção humana para revisão dessas avaliações.
            <br /><br />
            <strong>e) Transparência:</strong> comprometemo-nos a ser transparentes sobre como a IA é utilizada em nossa plataforma e quais dados alimentam nossos algoritmos.
          </Text>
        </Section>

        {/* DIREITOS DOS USUÁRIOS */}
        <Section>
          <SubTitle>13. Seus Direitos de Privacidade</SubTitle>
          <Text>
            De acordo com a LGPD e outras leis aplicáveis de proteção de dados, você possui os seguintes direitos:
            <br /><br />
            <strong>a) Direito de Acesso:</strong> você pode solicitar uma cópia dos seus dados pessoais que mantemos.
            <br /><br />
            <strong>b) Direito de Retificação:</strong> você pode solicitar a correção de dados imprecisos ou incompletos.
            <br /><br />
            <strong>c) Direito de Exclusão:</strong> você pode solicitar a exclusão dos seus dados pessoais em determinadas circunstâncias.
            <br /><br />
            <strong>d) Direito de Restrição:</strong> você pode solicitar que limitemos o processamento dos seus dados em determinadas circunstâncias.
            <br /><br />
            <strong>e) Direito de Portabilidade:</strong> você pode solicitar a transferência dos seus dados para outro serviço em formato estruturado.
            <br /><br />
            <strong>f) Direito de Oposição:</strong> você pode se opor ao processamento dos seus dados para marketing direto ou com base em interesses legítimos.
            <br /><br />
            <strong>g) Direito de Revogar Consentimento:</strong> quando o processamento é baseado no seu consentimento, você pode revogá-lo a qualquer momento.
            <br /><br />
            <strong>h) Direito de Reclamação:</strong> você tem o direito de apresentar uma reclamação à Autoridade Nacional de Proteção de Dados (ANPD).
          </Text>
        </Section>

        <Section>
          <SubTitle>14. Como Exercer Seus Direitos</SubTitle>
          <Text>
            Para exercer qualquer um dos direitos mencionados acima, você pode:
            <br /><br />
            <strong>a) Através do Aplicativo:</strong> acessar a seção "Privacidade e Dados" no menu de configurações do aplicativo.
            <br /><br />
            <strong>b) Por E-mail:</strong> enviar uma solicitação para privacidade@inglesfluencia.com.br, incluindo detalhes suficientes para identificar sua conta.
            <br /><br />
            <strong>c) Por WhatsApp:</strong> enviar a mensagem "Meus dados" para nosso número oficial, seguido da solicitação específica.
            <br /><br />
            Responderemos a todas as solicitações dentro do prazo legal de 15 dias, conforme estabelecido pela LGPD. Para proteger sua privacidade, podemos precisar verificar sua identidade antes de atender à sua solicitação.
          </Text>
        </Section>

        {/* DISPOSIÇÕES ESPECIAIS */}
        <Section>
          <SubTitle>15. Privacidade de Menores</SubTitle>
          <Text>
            Nossos serviços são destinados a pessoas com idade igual ou superior a 18 anos. No entanto, reconhecemos que adolescentes com idade entre 13 e 17 anos podem utilizar nossa plataforma com o consentimento dos pais ou responsáveis legais. Não coletamos intencionalmente dados pessoais de crianças menores de 13 anos. Se você acredita que coletamos informações de um menor de 13 anos sem a devida autorização parental, entre em contato conosco imediatamente para que possamos tomar as medidas necessárias para remover tais informações.
          </Text>
        </Section>

        <Section>
          <SubTitle>16. Comunicações de Marketing</SubTitle>
          <Text>
            Com seu consentimento, podemos enviar comunicações de marketing sobre novos recursos, promoções ou conteúdo educacional adicional. Você pode optar por não receber essas comunicações a qualquer momento:
            <br /><br />
            <strong>a) Respondendo "CANCELAR" ou "PARAR PROMOÇÕES" a qualquer mensagem promocional via WhatsApp;</strong>
            <br /><br />
            <strong>b) Clicando no link "cancelar inscrição" nos e-mails marketing;</strong>
            <br /><br />
            <strong>c) Ajustando suas preferências de comunicação no aplicativo;</strong>
            <br /><br />
            <strong>d) Entrando em contato com nosso suporte.</strong>
            <br /><br />
            Observe que mesmo que você opte por não receber comunicações de marketing, continuaremos enviando mensagens relacionadas ao serviço, como lembretes de exercícios, atualizações de conta e informações sobre sua assinatura.
          </Text>
        </Section>

        {/* DISPOSIÇÕES FINAIS */}
        <Section>
          <SubTitle>17. Alterações na Política de Privacidade</SubTitle>
          <Text>
            Podemos atualizar esta Política de Privacidade periodicamente para refletir alterações em nossas práticas ou por outros motivos operacionais, legais ou regulatórios. A versão mais recente estará sempre disponível em nosso site e aplicativo, com a data da última atualização. Para alterações significativas, forneceremos um aviso destacado, como uma notificação no aplicativo, uma mensagem via WhatsApp ou um e-mail. Recomendamos que você revise regularmente esta política para se manter informado sobre como protegemos suas informações.
          </Text>
        </Section>

        <Section>
          <SubTitle>18. Contato para Questões de Privacidade</SubTitle>
          <Text>
            Se você tiver dúvidas, preocupações ou comentários sobre esta Política de Privacidade, ou se desejar exercer seus direitos de proteção de dados, entre em contato conosco:
            <br /><br />
            <strong>E-mail:</strong> privacidade@inglesfluencia.com.br
            <br />
            <strong>WhatsApp:</strong> 11 98196-1451 (envie a mensagem "Privacidade")
            <br />
            <strong>Encarregado de Proteção de Dados (DPO):</strong> dpo@inglesfluencia.com.br
            <br />
            <strong>Endereço Postal:</strong> 
            <br /><br />
            Comprometemo-nos a resolver qualquer dúvida ou reclamação que você possa ter sobre nosso uso dos seus dados pessoais.
          </Text>
        </Section>

        <Section>
          <Text>
            Última atualização desta Política de Privacidade: Abril de 2025.
          </Text>
        </Section>

        <BackButton>
          <Link to="/">Voltar para a página inicial</Link>
        </BackButton>
      </Container>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
